import styled from 'styled-components';
import { triangle } from 'polished';
import { dropShadowLarge, blur } from '../theme/css';
import { borderRadius } from '../theme/border-radius';
import Box from '../box';
export const TooltipContentContainer = styled(Box) `
  @apply absolute w-auto overflow-visible rounded-xl px-2 py-1;

  top: ${(props) => props.top};
  left: ${(props) => props.left};
  z-index: 1000;
  border-radius: ${borderRadius.sm};
  ${dropShadowLarge};
  ${blur};

  &:before {
    @apply absolute right-1/2 -top-2.5;
    display: ${(props) => (props.showArrow ? 'inline-block' : 'none')};
    content: '';
    transform: translateX(50%);
    ${triangle({
    pointingDirection: 'top',
    width: '20px',
    height: '10px',
    foregroundColor: 'white',
})};
    border-bottom-color: rgba(var(--bg-color), 0.85);
  }
`;
export const TooltipContainer = styled.div `
  @apply cursor-pointer w-min;
`;
